import "./Footer.css"

const footerLinks = {
    social: {text: "Socials", link:`https://jargueta.carrd.co/`},
    resume: {text: "Resume", link:`#/resume`},
    email: {text: "Email", link:`mailto: jerargueta.contact@gmail.com`},
};

function Footer({onTabClicked}){
    return(
        <div name="footer" className="row text-center footer-links">
            {Object.keys(footerLinks).map((key) => <Links key={key} button={footerLinks[key]} clicked={onTabClicked}/>)}
        </div>
    );
}

function Links({button, clicked}){
    return(
        <div className="col-md-4">
            <a href={button.link} target="_blank" onClick={() => button.link === "#/resume" && clicked(button.link)}>{button.text}</a>
        </div>
    );
}

export default Footer